export default __webpack_public_path__ + "./assets/home-banner__0a2553e5ff679fcb412da76d98958a19.png";